var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatIconMarketplace({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.50001 1.25C4.04813 1.25 1.25001 4.04813 1.25001 7.5C1.24781 8.97725 1.77082 10.4072 2.72563 11.5344L1.96438 12.8031C1.90741 12.898 1.87663 13.0062 1.87518 13.1168C1.87373 13.2274 1.90166 13.3364 1.95613 13.4327C2.0106 13.529 2.08964 13.6091 2.1852 13.6649C2.28075 13.7206 2.38938 13.75 2.50001 13.75H7.50001C7.72991 13.5417 8.05177 13 7.50001 12.5H3.60376L4.03751 11.7775C4.10877 11.6585 4.13842 11.5192 4.12178 11.3815C4.10515 11.2438 4.04318 11.1155 3.94563 11.0169C3.25162 10.3155 2.78063 9.4245 2.59197 8.45602C2.40332 7.48753 2.50542 6.48488 2.88543 5.5743C3.26545 4.66373 3.90638 3.88594 4.72752 3.33888C5.54867 2.79182 6.51332 2.49994 7.50001 2.5C8.82609 2.5 10.0979 3.02678 11.0355 3.96447C11.9732 4.90215 12.5 6.17392 12.5 7.5C12.7299 7.70833 13.3018 8 13.75 7.5C13.75 4.04813 10.9519 1.25 7.50001 1.25Z",
    fill: "#666666"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4324_40287)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5 8.7998C12.9913 8.7998 14.2002 10.0087 14.2002 11.5C14.2002 12.9913 12.9913 14.2002 11.5 14.2002C10.0087 14.2002 8.7998 12.9913 8.7998 11.5C8.7998 10.0087 10.0087 8.7998 11.5 8.7998ZM11.5 9.3877C10.3335 9.3877 9.3877 10.3335 9.3877 11.5C9.3877 12.6665 10.3335 13.6123 11.5 13.6123C12.6665 13.6123 13.6123 12.6665 13.6123 11.5C13.6123 10.3335 12.6665 9.3877 11.5 9.3877ZM11.498 9.9209C11.5661 9.919 11.6389 9.93639 11.6963 9.98047C11.756 10.0264 11.7939 10.0976 11.7939 10.1875V11.4248H13.0312C13.2473 11.4248 13.3799 11.5607 13.3799 11.7188C13.3799 11.8768 13.2473 12.0127 13.0312 12.0127H11.2061V10.1875C11.2061 10.1016 11.2456 10.0334 11.3027 9.98828C11.3583 9.94452 11.4298 9.92284 11.498 9.9209Z",
    fill: "#666666",
    stroke: "#666666",
    strokeWidth: 0.15
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4324_40287"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIconMarketplace);
export default __webpack_public_path__ + "static/media/chatIconMarketplace.94158fb9f3a701c49b10e3edaddc4e92.svg";
export { ForwardRef as ReactComponent };